import clsx from "clsx";
import { Col, ModalProps, useModal } from "@commonlibs";
import { createModal } from "@commonlibs";
import type { LocalGiftCardDto } from "common/models/api/models/LocalGiftCardDto";
import Modal from "ui/common/components/feedback/Modal/Modal";
import ModalFooter from "ui/common/components/feedback/Modal/ModalFooter/ModalFooter";
import useTranslate from "ui/locale/hooks/useTranslate";
import { Typography } from "@commonlibs";
import useDeleteGiftCard from "features/giftcards/hooks/useDeleteGiftCard";

const DeleteGiftCardModal = createModal<{ giftCard: LocalGiftCardDto } & ModalProps>(({ className, giftCard, ...rest }) => {
    const translate = useTranslate();
    const { hideModal } = useModal();

    const { mutate: deleteGiftCard, isLoading: isDeletingGiftCard } = useDeleteGiftCard({ onSuccess: closeModal });

    function closeModal() {
        hideModal(DeleteGiftCardModal.id);
    }

    function onDelete() {
        deleteGiftCard(giftCard.id.toString());
    }

    return (
        <Modal
            title={translate("deleteGiftCard")}
            className={clsx("delete-gift-card-modal", className)}
            style={{ width: "550px" }}
            {...rest}
        >
            <Col style={{ marginBottom: "25px" }} gap={10}>
                <Typography variant="body2Regular" style={{ whiteSpace: "pre-line" }}>
                    {translate("deleteGiftCardModalMessage")}
                </Typography>
            </Col>
            <ModalFooter
                isLoading={isDeletingGiftCard}
                cancelLabel={translate("goOut") as string}
                mainLabel={translate("delete")}
                onCancel={closeModal}
                onSubmit={onDelete}
            />
        </Modal>
    );
});

export default DeleteGiftCardModal;
